import { em } from 'polished'
import styled, { css } from 'styled-components'

import FrameBrowser from 'components/FrameBrowser'

export const Cover = styled.div`
  position: absolute;
  right: 0;
  height: 100%;
  background: ${p => p.theme.colors.catskillWhite};
  display: ${p => (p.isTablet ? 'none' : 'block')};

  ${({ isTablet }) =>
    isTablet
      ? css`
          width: 57%;
        `
      : css`
          width: 90%;
        `}

  ${p => p.theme.mq.upMd} {
    display: ${p => (p.isTablet ? 'block' : 'none')};
  }

  ${p => p.theme.mq.upLg} {
    width: 55%;
  }
`

export const Content = styled.article`
  min-height: 0;
  display: flex;
  align-items: center;

  ${p => p.theme.mq.upMd} {
    min-height: ${p => p.theme.blocks.heightMinResultsMd};
  }

  ${p => p.theme.mq.upLg} {
    min-height: ${p => p.theme.blocks.heightMinResultsLg};
  }
`

export const FrameWrapper = styled.div`
  position: relative;
  min-height: ${p => p.theme.blocks.heightMinResults};
`

export const FrameBrowserStyled = styled(FrameBrowser)`
  margin: 0 auto;

  ${p => p.theme.mq.upMd} {
    margin: 0 0 ${em(40)};
  }
`
